import { render, staticRenderFns } from "./banner-detail.vue?vue&type=template&id=57ef97c7&scoped=true"
import script from "./banner-detail.vue?vue&type=script&lang=js"
export * from "./banner-detail.vue?vue&type=script&lang=js"
import style0 from "./banner-detail.vue?vue&type=style&index=0&id=57ef97c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef97c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ef97c7')) {
      api.createRecord('57ef97c7', component.options)
    } else {
      api.reload('57ef97c7', component.options)
    }
    module.hot.accept("./banner-detail.vue?vue&type=template&id=57ef97c7&scoped=true", function () {
      api.rerender('57ef97c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/banner-detail.vue"
export default component.exports